import { FC } from 'react'
import { Wrapper } from './styled'
import CoursesTab from './CoursesTab'

const MyCourses: FC = () => {
  return (
    <Wrapper>
      <CoursesTab />
    </Wrapper>
  )
}

export default MyCourses
